import React, { useMemo } from 'react';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { useGlobalLocale } from '@gov-nx/core/service';
import { DataTable } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';

interface GridSkeletonProps {
	rows: number;
	ariaLabel?: string;
}

export const GridSkeleton = ({
	rows,
	ariaLabel: passedAriaLabel,
}: GridSkeletonProps) => {
	const tableRows = useMemo(
		() => Array.from({ length: rows }).map((_, i) => i),
		[rows]
	);

	const { t } = useGlobalLocale();

	const ariaLabel = passedAriaLabel ?? t('loading.wcag.processing');

	return (
		<DataTable responsive>
			<tbody>
				{tableRows.map((rowIdx) => (
					<tr key={rowIdx}>
						<td className="sm:w-1/2!">
							<GovSkeleton
								height="19px"
								width={generateRandomNumber(30, 60) + '%'}
								aria-label={ariaLabel}
							/>
						</td>
						<td>
							<GovSkeleton
								height="19px"
								width={generateRandomNumber(30, 60) + '%'}
								aria-label={ariaLabel}
								className="flex grow"
							/>
						</td>
					</tr>
				))}
			</tbody>
		</DataTable>
	);
};
